(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["klyvens-dental-product"] && !Shopify.designMode) return;
  try {
    
  class KlyvensDentalPage {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-kd-track]');
      this.slides = [...root.querySelectorAll('[data-kd-slide]')];
      this.dots = [...root.querySelectorAll('[data-kd-dot]')];
      this.index = 0;
      this.touchStart = null;
      this.bindGallery();
      this.bindOffers();
    }

    bindGallery() {
      this.root.querySelector('[data-kd-prev]')?.addEventListener('click', () => this.show(this.index - 1));
      this.root.querySelector('[data-kd-next]')?.addEventListener('click', () => this.show(this.index + 1));
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index)));
      const viewport = this.root.querySelector('.kd-gallery__viewport');
      viewport?.addEventListener('touchstart', event => { this.touchStart = event.touches[0].clientX; }, { passive: true });
      viewport?.addEventListener('touchend', event => {
        if (this.touchStart === null) return;
        const distance = event.changedTouches[0].clientX - this.touchStart;
        if (Math.abs(distance) > 45) this.show(this.index + (distance < 0 ? 1 : -1));
        this.touchStart = null;
      }, { passive: true });
    }

    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.track.style.transform = `translate3d(-${this.index * 100}%, 0, 0)`;
      this.dots.forEach((dot, dotIndex) => {
        if (dotIndex === this.index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    bindOffers() {
      const quantity = this.root.querySelector('[data-kd-quantity]');
      this.root.querySelectorAll('[data-kd-offer]').forEach(input => {
        input.addEventListener('change', () => {
          if (quantity) quantity.value = input.value;
          this.root.querySelectorAll('.kd-offer').forEach(label => label.classList.remove('kd-offer--selected'));
          input.closest('.kd-offer')?.classList.add('kd-offer--selected');
        });
      });
    }
  }

  document.querySelectorAll('[data-kd-root]').forEach(root => {
    if (!root.dataset.kdReady) {
      root.dataset.kdReady = 'true';
      new KlyvensDentalPage(root);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
